export const COLLABORATION_SERVICES_LABEL = 'Prestations de la Collaboration';
